import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useAuth } from "./hooks/context/useAuth";
import PrivateRoute from "./routers/PrivateRoute";
import PublicRoute from "./routers/PublicRoute";
import Layout from "./layouts";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgot_password";
import Loading from "./components/common/loading";
import NotFoundPage from "./pages/not_found";
import AccessDenied from "./pages/access_denied";
import { useOrgApp } from "./hooks/context/useOrgApp";
import { defaultRoute } from "./data/global";
import useModules from "./hooks/services/profile/useModules";

function App() {
  const { auth: { isAuthenticated, isExpiredSubscription } } = useAuth();
  const { isSelectedOrg } = useOrgApp();
  const { modules } = useModules();
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Authentication - Private Route"  */}
          <Route element={<PrivateRoute isAllowed={isAuthenticated} />}>
            {/* 403/access-denied - Expired Subscription */}
            <Route element={<PrivateRoute isAllowed={isExpiredSubscription} />}>
              <Route path="/access-denied" element={<AccessDenied />} />
            </Route>

            {/* Routes including Layout */}
            <Route element={<PrivateRoute path="/access-denied" isAllowed={!isExpiredSubscription} />}>
              <Route element={<Layout />}>
                {/* Require selecting Organisation - Domain  */}
                <Route element={<PrivateRoute path={defaultRoute} isAllowed={isSelectedOrg()} />}>
                  {modules.map((module) => module.onPlan &&
                    <Route path={module.path} element={<module.Component {...module.options} />} />
                  )}
                </Route>
                {/* Does Not Require selecting Organisation - Domain  */}
                {modules.map((module) => !module.onPlan &&
                  <Route path={module.path} element={<module.Component {...module.options} />} />
                )}
              </Route>
            </Route>
          </Route>

          {/* Redirect to Home for Authenticated users " */}
          <Route element={<PublicRoute isDenied={isAuthenticated} />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Route>

          {/* 404/non-exist route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
